<template>
  <v-container
    class="mx-0"
    fluid
  >
    <v-row>
      <v-col :cols="cols">
        <cusip-search-box />
        <cusip-search-results />
      </v-col>
      <v-col :cols="6" v-if="selectedProperty">
        <property-details />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import CusipSearchBox from '@/components/CusipSearchBox.vue'
import CusipSearchResults from '@/components/CusipSearchResults.vue'
import PropertyDetails from '@/components/PropertyDetails.vue'

import { mapState } from 'vuex'

export default {
  name: 'Securities',
  components: {
    CusipSearchBox,
    CusipSearchResults,
    PropertyDetails
  },
  computed: {
    cols() {
      return this.selectedProperty ? 6 : 12
      // return true
    },
    ...mapState(['selectedProperty'])
  }
}
</script>
